import { TaskDetails } from '../../leadsDetail/LeadsDetailRepository';

// Explicit request: a "Book a Meeting" entry is done - so it loses its orange colour and upcoming card - as
// soon as anything later in the activity shows the meeting was dealt with, not just a "Had Meeting" log:
//  - a newer booking superseded it,
//  - a meeting task created from / after it has been completed,
//  - a Had Meeting follow-up was logged after it,
//  - the enquiry reached an outcome after it (proceeding -> create matter / client, not proceeding, or a
//    matter / client was created).
export const isBookMeetingDone = (task: TaskDetails, tasks: TaskDetails[]): boolean => {
    if (task.taskTypeInternalDescription !== 'BookMeeting') {
        return false;
    }
    const bookedAt = task.createdDate ? new Date(task.createdDate).getTime() : 0;
    const timeOf = (other: TaskDetails): number => {
        const date = other.completedDate ?? other.createdDate;
        return date ? new Date(date).getTime() : 0;
    };
    return tasks.some((other: TaskDetails) => {
        if (other === task) {
            return false;
        }
        if (other.taskTypeInternalDescription === 'BookMeeting') {
            const otherCreated = other.createdDate ? new Date(other.createdDate).getTime() : 0;
            return otherCreated > bookedAt;
        }
        if (timeOf(other) < bookedAt) {
            return false;
        }
        const outcome = other.outcome ? other.outcome.toLowerCase() : '';
        const typeDescription = other.taskTypeDescription ? other.taskTypeDescription.toLowerCase() : '';
        return (other.taskTypeInternalDescription === 'MeetingTask' && !!other.completedDate)
            || other.followUpActionSystemName === 'HadMeeting'
            || outcome === 'proceeding'
            || outcome === 'not proceeding'
            || typeDescription === 'create matter'
            || typeDescription === 'create client';
    });
};
